import React from 'react';
import { CheckCircle, AlertCircle, Clock, RefreshCw } from 'lucide-react';
/**
 * Returns a sized icon with the correct semantic color for a given transcription status.
 * Used in list rows, history items, and anywhere a status indicator icon is needed.
 */
export function getStatusIcon(status: string | undefined, size: number = 16) {
  switch (status) {
    case 'completed':
      return <CheckCircle size={size} className="text-success" data-id="element-1918" />;
    case 'processing':
    case 'pending':
      return <Clock size={size} className="text-info" data-id="element-1919" />;
    case 'failed':
      return <AlertCircle size={size} className="text-destructive" data-id="element-1920" />;
    default:
      return <Clock size={size} className="text-muted-foreground" data-id="element-1921" />;
  }
}
/**
 * Returns a pill badge JSX element with icon + label for a given transcription status.
 * Used in card headers, table rows, and anywhere a status badge is needed.
 */
export function getStatusBadge(status: string | undefined) {
  switch (status) {
    case 'completed':
      return <span className="flex items-center gap-1 text-xs font-medium text-success bg-success/10 px-2 py-0.5 rounded-full" data-id="element-1922">
          <CheckCircle size={12} data-id="element-1923" />
          <span data-id="element-1924">Completed</span>
        </span>;
    case 'processing':
    case 'pending':
      return <span className="flex items-center gap-1 text-xs font-medium text-info bg-info/10 px-2 py-0.5 rounded-full" data-id="element-1925">
          <RefreshCw size={12} className="animate-spin" data-id="element-1926" />
          <span data-id="element-1927">Processing</span>
        </span>;
    case 'failed':
      return <span className="flex items-center gap-1 text-xs font-medium text-destructive bg-destructive/10 px-2 py-0.5 rounded-full" data-id="element-1928">
          <AlertCircle size={12} data-id="element-1929" />
          <span data-id="element-1930">Failed</span>
        </span>;
    default:
      return null;
  }
}